/*
 * Copied over from wave2-player renderer/restrictions.js revision 49d7a44
 * Notable changes:
 *   * Replaced `module.exports` with `export default`
 *   * Removed use of `global.player` from `shouldPlay`
 */

/* eslint-disable */
/**
 * Parses ISO string into local date
 *
 * @param {string} s - ISO DateTime representation
 * @returns {Date} parsed Date object
 */
function parseLocalDate(s) {
  if (typeof s != 'string') {
    return new Date(undefined);
  }

  const ds = s.split(/\D/).map(e => parseInt(e, 10));
  ds[1] -= 1; // adjust month
  return new Date(...ds);
}

/**
 * Checks whether specified medium should be shown on specified Date based on
 * daytime restrictions
 *
 * @param {Medium} medium - analyzed medium object
 * @param {Date} timestamp - expected playback start timestamp
 * @returns {Boolean} true if medium should be displayed
 */
function daytimeMatch(medium, timestamp) {
  if (medium.PlayListItem_DaytimeRestrictions === undefined
      || medium.PlayListItem_DaytimeRestrictions.length === 0) {
    return true;
  }

  const dayList = [
    'Sunday', 'Monday', 'Tuesday', 'Wednesday',
    'Thursday', 'Friday', 'Saturday'];

  const currentDay = dayList[timestamp.getDay()];

  for (const restriction of medium.PlayListItem_DaytimeRestrictions) {
    const start = restriction[`start_${currentDay}`].split(':').map(e => parseInt(e, 10));
    const end = restriction[`end_${currentDay}`].split(':').map(e => parseInt(e, 10));
    if (start.length === 2 && end.length === 2) {
      const startMinute = start[0] * 60 + start[1];
      const endMinute = end[0] * 60 + end[1];

      const currentMinute = timestamp.getHours() * 60 + timestamp.getMinutes();
      const validFrom = parseLocalDate(restriction.validFrom);
      const validTo = parseLocalDate(restriction.validTo);
      // End date inclusive - this will roll over to 00:00 of the following day
      // (local time)
      validTo.setHours(24);

      const valid = (Number.isNaN(validFrom.getTime()) || timestamp.getTime() > validFrom.getTime()) && (Number.isNaN(validTo.getTime()) || timestamp.getTime() < validTo.getTime());
      if (currentMinute >= startMinute && currentMinute < endMinute && valid) {
        return true;
      }
    }
  }

  return false;
}

/**
 * Checks whether specified medium should be shown on specified Date based on
 * date restrictions
 *
 * @param {Medium} medium - analyzed medium object
 * @param {Date} timestamp - expected playback start timestamp
 * @returns {Boolean} true if medium should be displayed
 */
function dateMatch(medium, timestamp) {
  if (medium.PlayListItem_DateRestrictions === undefined
      || medium.PlayListItem_DateRestrictions.length === 0) {
    return true;
  }

  for (const restriction of medium.PlayListItem_DateRestrictions) {
    const start = parseLocalDate(restriction.firstPlayDate);
    const end = parseLocalDate(restriction.lastPlayDate);
    if ((Number.isNaN(start.getTime()) || timestamp >= start)
        && (Number.isNaN(end.getTime()) || timestamp < end)) {
      return true;
    }
  }

  return false;
}

/**
 * Temporary helper function to support parent medium restrictions stored as
 * stringly typed JSON. To be disposed of after merging relevant wave2-server
 * PR.
 *
 * @private
 */
function parseMediaRestrictions(r) {
  if (Array.isArray(r)) {
    return r;
  }

  if (typeof r === 'string') {
    return JSON.parse(r);
  }

  return [];
}

/**
 * Checks whether specified medium should be shown based on parent playlists
 *
 * @param {Medium} medium - analyzed medium object
 * @param {Date} timestamp - expected playback start timestamp
 * @returns {Boolean} true if medium should be displayed
 */
function mediumMatch(medium, timestamp) {
  if (medium.path === undefined) {
    return true;
  }

  const forbidden = parseMediaRestrictions(medium.playForbiddenInMedia);
  const only = parseMediaRestrictions(medium.playOnlyInMedia);

  const path = medium.path.split('/').map(i => parseInt(i, 10));

  if (forbidden.findIndex(e => path.includes(e)) !== -1) {
    return false;
  }

  if (only.length !== 0 && only.findIndex(e => path.includes(e)) === -1) {
    return false;
  }

  return true;
}

/**
 * Check all supported medium playback restrictions
 *
 * @param {Medium} medium - analyzed medium object
 * @param {Date} timestamp - expected playback start timestamp
 * @returns {Boolean} true if medium should be displayed
 */
function shouldPlay(medium, timestamp = new Date()) {
  // Apply parent restrictions (see tree.js:flatten)
  if (medium._parents) {
    if (!medium._parents.reduce((rest, p) => rest && shouldPlay(p, timestamp), true)) {
      return false;
    }
  }

  try {
    // FIXME player needs to be somehow accessible without global context
    // pollution
    /**
     * dateMatch({ PlayListItem_DateRestrictions: global.player.schedule.date }, timestamp)
      && daytimeMatch({
        PlayListItem_DaytimeRestrictions: global.player.schedule.daytime
      }, timestamp)
      && 
     */
    return daytimeMatch(medium, timestamp)
      && dateMatch(medium, timestamp)
      && mediumMatch(medium, timestamp);
  } catch (e) {
    console.warn('Restrictions calculation failed', e);
    return false;
  }
}

export default {
  shouldPlay,
  daytimeMatch,
  dateMatch
};



// WEBPACK FOOTER //
// ./src/components/Common/restrictions.js